import { lazy } from 'react'
import { Navigate } from 'react-router-dom'
import Loadable from '../layouts/loader/Loadable'

/****Layouts*****/

const FullLayout = Loadable(lazy(() => import('../layouts/FullLayout')))
const BlankLayout = Loadable(lazy(() => import('../layouts/BlankLayout')))
/***** Pages ****/

const Analytical = Loadable(lazy(() => import('../views/dashboards/Analytical')))
const Demographical = Loadable(lazy(() => import('../views/dashboards/Demographical')))
const Modern = Loadable(lazy(() => import('../views/dashboards/Modern')))
const About = Loadable(lazy(() => import('../views/About')))

/***** Apps ****/
const Notes = Loadable(lazy(() => import('../views/apps/notes/Notes')))
const Chat = Loadable(lazy(() => import('../views/apps/chat/Chat')))
const Contacts = Loadable(lazy(() => import('../views/apps/contacts/Contacts')))
const Calendar = Loadable(lazy(() => import('../views/apps/calendar/CalendarApp')))
const Email = Loadable(lazy(() => import('../views/apps/email/Email')))
const Shop = Loadable(lazy(() => import('../views/apps/ecommerce/Shop')))
const ShopDetail = Loadable(lazy(() => import('../views/apps/ecommerce/ShopDetail')))
const Treeview = Loadable(lazy(() => import('../views/apps/treeview/TreeView')))
const TicketList = Loadable(lazy(() => import('../views/apps/ticket/TicketList')))
const TicketDetail = Loadable(lazy(() => import('../views/apps/ticket/TicketDetail')))

/***** Dashboard ***/
const Dashboard = Loadable(lazy(() => import('../views/Dashboard/Dashboard')))
const AgentDashboard = Loadable(lazy(() => import('../views/Dashboard/Agent/Dashboard')))

/***** Orders ***/
const Quotation = Loadable(lazy(() => import('../views/Orders/Quotation/Quotation')))
// const AddEditQuotation = Loadable(lazy(() => import('../views/Orders/Quotation/AddEdit/AddEditQuotation')))
const AddEditQuotationNew = Loadable(lazy(() => import('../views/Orders/Quotation/AddEdit/AddEditQuotationNew')))
const PickupOrder = Loadable(lazy(() => import('../views/Orders/PickupOrder/PickupOrder')))
const AddEditPickupOrder = Loadable(lazy(() => import('../views/Orders/PickupOrder/AddEdit/AddEditPickupOrder')))

/***** Transactions ***/

const Warehousereceipt = Loadable(lazy(() => import('../views/Transactions/warehouserreceipt/Warehousereceipt')))
const AddWarehouse = Loadable(lazy(() => import('../views/Transactions/warehouserreceipt/add/AddWarehouse')))
const InhouseWayBill = Loadable(lazy(() => import('../views/Transactions/InhouseWayBill/InhouseWayBill')))
const AddEditInhouseWayBill = Loadable(lazy(() => import('../views/Transactions/InhouseWayBill/AddEdit/AddEditInhouseWayBill')))
const EditInhouseWayBill = Loadable(lazy(() => import('../views/Transactions/InhouseWayBill/AddEdit/EditInhouseWayBill')))
const Masterwaybill = Loadable(lazy(() => import('../views/Transactions/MasterWayBill/Masterwaybill')))
const EditMasterWayBill = Loadable(lazy(() => import('../views/Transactions/MasterWayBill/AddEdit/EditMasterWayBill')))
const Addeditmasterwaybill = Loadable(lazy(() => import('../views/Transactions/MasterWayBill/AddEdit/Addeditmasterwaybill')))
const PickingList = Loadable(lazy(() => import('../views/Transactions/PickingList')))
const AddEditPickingList = Loadable(lazy(() => import('../views/Transactions/AddEditPickingList')))
const PackingList = Loadable(lazy(() => import('../views/Transactions/PackingList/PackingList')))
const AddEditPackingList = Loadable(lazy(() => import('../views/Transactions/PackingList/AddEdit/AddEditPackingList')))
const CargoRelease = Loadable(lazy(() => import('../views/Transactions/CargoRelease/CargoRelease')))
const AddEditCargoReleasepage = Loadable(lazy(() => import('../views/Transactions/CargoRelease/AddEdit/AddEditCargoReleasepage')))
const Liquidation = Loadable(lazy(() => import('../views/Transactions/Liquidation/Liquidation')))
const Invoice = Loadable(lazy(() => import('../views/Transactions/Invoice/Invoice')))
const PaymentHistory = Loadable(lazy(() => import('../views/Transactions/PaymentHistory/PaymentHistory')))
const TransactionDetails = Loadable(lazy(() => import('../views/Transactions/PaymentHistory/TransactionDetails')))
const Tasks = Loadable(lazy(() => import('../views/Transactions/Tasks/Tasks')))
const RulesDescription = Loadable(lazy(() => import('../views/Transactions/RulesDescription/RulesDescription')))
const ProjectRequestDashboard = Loadable(lazy(() => import('../views/Transactions/ProjectRequestDashboard/ProjectRequestDashboard')))
const AddEditRulesDescription = Loadable(lazy(() => import('../views/Transactions/RulesDescription/AddEdit/AddEditRulesDescription')))
const AddEditProjectRequestDashboard = Loadable(lazy(() => import('../views/Transactions/ProjectRequestDashboard/AddEdit/AddEditProjectRequestDashboard')))
const RuleforCountry = Loadable(lazy(() => import('../views/Transactions/RuleforCountry')))
const AddEditRuleforCountry = Loadable(lazy(() => import('../views/Transactions/AddEditRuleforCountry')))


/***** customer ***/

const AddCustomer = Loadable(lazy(() => import('../views/Customers/AddCustomer')))
const AddEditCustomer = Loadable(lazy(() => import('../views/Customers/AddEdit/AddEditCustomer')))

/***** WareHouse ***/

const WareHouseZone = Loadable(lazy(() => import('../views/WareHouse/WareHouseZone/WareHouseZone')))
const AddEditWareHouseZone = Loadable(lazy(() => import('../views/WareHouse/WareHouseZone/AddEdit/AddEditWareHouseZone')))
const WareHouseLocation = Loadable(lazy(() => import('../views/WareHouse/WareHouseLocation/WareHouseLocation')))
const AddEditWareHouseLocation = Loadable(lazy(() => import('../views/WareHouse/WareHouseLocation/AddEdit/AddEditWareHouseLocation')))
const WareHouseRack = Loadable(lazy(() => import('../views/WareHouse/WareHouseRack/WareHouseRack')))
const AddEditWareHouseRack = Loadable(lazy(() => import('../views/WareHouse/WareHouseRack/AddEdit/AddEditWareHouseRack')))
const WareHouseShelve = Loadable(lazy(() => import('../views/WareHouse/WareHouseShelve/WareHouseShelve')))
const AddEditWareHouseShelve = Loadable(lazy(() => import('../views/WareHouse/WareHouseShelve/AddEdit/AddEditWareHouseShelve')))
const AddWarehouseGrid = Loadable(lazy(() => import('../views/WareHouse/AddWarehouse/AddWarehouseGrid')))
const Warehouse = Loadable(lazy(() => import('../views/WareHouse/Warehouse/Warehouse')))
const AddEditWarehouse = Loadable(lazy(() => import('../views/WareHouse/Warehouse/AddEdit/AddEditWarehouse')))
const ItemInventory = Loadable(lazy(() => import('../views/WareHouse/ItemInventory/ItemInventory')))

/***** Rates ***/

const CustomerRate = Loadable(lazy(() => import('../views/Rates/CustomerRates/CustomerRate')))
const AddEditCustomerRate = Loadable(lazy(() => import('../views/Rates/CustomerRates/AddEdit/AddEditCustomerRate')))
const AgencyRate = Loadable(lazy(() => import('../views/Rates/AgencyRates/AgencyRate')))
const AddEditAgencyRate = Loadable(lazy(() => import('../views/Rates/AgencyRates/AddEdit/AddEditAgencyRate')))
const RateUnit = Loadable(lazy(() => import('../views/Rates/RateUnit')))
const CarrierRate = Loadable(lazy(() => import('../views/Rates/CarrierRates/CarrierRate')))
const AddEditCarrierRate = Loadable(lazy(() => import('../views/Rates/CarrierRates/AddEdit/AddEditCarrierRate')))
const StorageRate = Loadable(lazy(() => import('../views/Rates/StorageRates/StorageRate')))
const AddEditStorageRate = Loadable(lazy(() => import('../views/Rates/StorageRates/AddEdit/AddEditStorageRate')))

/***** Master ***/

const Country = Loadable(lazy(() => import('../views/Master/Country')))
const State = Loadable(lazy(() => import('../views/Master/State')))
const Cities = Loadable(lazy(() => import('../views/Master/Cities')))
const Port = Loadable(lazy(() => import('../views/Master/Port')))
const EditCountry = Loadable(lazy(() => import('../views/Master/EditCountry')))
const EditState = Loadable(lazy(() => import('../views/Master/EditState')))
const EditCity = Loadable(lazy(() => import('../views/Master/EditCity')))
const AddEditPort = Loadable(lazy(() => import('../views/Master/AddEditPort')))
const PushNotifications = Loadable(lazy(() => import('../views/Master/PushNotifications')))
const AddEditPushNotifications = Loadable(lazy(() => import('../views/Master/AddEditPushNotifications')))
const Commodity = Loadable(lazy(() => import('../views/Master/Commodity')))
const Plans = Loadable(lazy(() => import('../views/Master/Plans')))
const AddandEditPlans = Loadable(lazy(() => import('../views/Master/AddandEditPlans')))
const AddEditCommodity = Loadable(lazy(() => import('../views/Master/AddEditCommodity')))
const PostArticleCategories = Loadable(lazy(() => import('../views/Master/PostArticleCategories')))
const AddEditPostArticleCategories = Loadable(lazy(() => import('../views/Master/AddEditPostArticleCategories')))
const Agency = Loadable(lazy(() => import('../views/Master/Agency')))
const AddandEditAgency = Loadable(lazy(() => import('../views/Master/AddandEditAgency')))
const Carrier = Loadable(lazy(() => import('../views/Master/Carrier')))
const AddandEditCarrier = Loadable(lazy(() => import('../views/Master/AddandEditCarrier')))
const BusinessType = Loadable(lazy(() => import('../views/Master/BusinessType')))
const AddandEditBusinesstype = Loadable(lazy(() => import('../views/Master/AddandEditBusinesstype')))
const AdditionalUsers = Loadable(lazy(() => import('../views/Master/AdditionalUsers')))
const AddEditAdditionalUsers = Loadable(lazy(() => import('../views/Master/AddEditAdditionalUsers')))
const Service = Loadable(lazy(() => import('../views/Master/Service')))
const AddEditService = Loadable(lazy(() => import('../views/Master/AddEditService')))
const Package = Loadable(lazy(() => import('../views/Master/Package')))
const AddEditPackage = Loadable(lazy(() => import('../views/Master/AddEditPackage')))
const QuickService = Loadable(lazy(() => import('../views/Master/QuickService')))
const AddEditQuickService = Loadable(lazy(() => import('../views/Master/AddEditQuickService')))

/***** Settings ****/
const Hub = Loadable(lazy(() => import('../views/settings/Hub')))
const AddEditHub = Loadable(lazy(() => import('../views/settings/AddEditHub')))
const HubZone = Loadable(lazy(() => import('../views/settings/HubZone')))
const AddEditHubZone = Loadable(lazy(() => import('../views/settings/AddEditHubZone')))
// const HubAndHubZone = Loadable(lazy(() => import('../views/settings/HubAndHubZone')));
// const HubZoneAndHub = Loadable(lazy(() => import('../views/settings/HubZoneAndHub')));
const ItemStatus = Loadable(lazy(() => import('../views/settings/ItemStatus')))
const AddEditItemStatus = Loadable(lazy(() => import('../views/settings/AddEditItemStatus')))
const AddEditMasterStatus = Loadable(lazy(() => import('../views/settings/AddEditMasterStatus')))
const RateType = Loadable(lazy(() => import('../views/settings/RateType')))
const AddEditRateType = Loadable(lazy(() => import('../views/settings/AddEditRateType')))
const CustomerType = Loadable(lazy(() => import('../views/settings/CustomerType')))
const AddEditCustomerType = Loadable(lazy(() => import('../views/settings/AddEditCustomertype')))
const Paymenttype = Loadable(lazy(() => import('../views/settings/Paymenttype')))
const AddEditpaymenttype = Loadable(lazy(() => import('../views/settings/AddEditPaymenttype')))
const Paymentgateway = Loadable(lazy(() => import('../views/settings/Paymentgateway')))
const AddEditpaymentgateway = Loadable(lazy(() => import('../views/settings/AddEditpaymentgateway')))
const PackageType = Loadable(lazy(() => import('../views/settings/PackageType')))
const AddEditPackageType = Loadable(lazy(() => import('../views/settings/AddEditPackageType')))
const AdditionalServices = Loadable(lazy(() => import('../views/settings/AdditionalServices')))
const AddEditAdditonSRV = Loadable(lazy(() => import('../views/settings/AddEditAdditonSRV')))
const ShipmentType = Loadable(lazy(() => import('../views/settings/ShipmentType')))
const ServiceType = Loadable(lazy(() => import('../views/settings/ServiceType')))
const AddEditServiceType = Loadable(lazy(() => import('../views/settings/AddEditServiceType')))
const AddEditShipmentType = Loadable(lazy(() => import('../views/settings/AddEditShipmentType')))
const Branch = Loadable(lazy(() => import('../views/settings/Branch')))
const AddEditBranch = Loadable(lazy(() => import('../views/settings/AddEditBranch')))
const CustomerAccountType = Loadable(lazy(() => import('../views/settings/CustomerAccountType')))
const AddEditCustAccType = Loadable(lazy(() => import('../views/settings/AddEditCustAccType')))
const DriverInfo = Loadable(lazy(() => import('../views/settings/DriverInfo')))
const AddEditDriverInfo = Loadable(lazy(() => import('../views/settings/AddEditDriverInfo')))
const WeightmeasurementUnits = Loadable(lazy(() => import('../views/settings/WeightmeasurementUnits')))
const AddEditWeightMesmentUnit = Loadable(lazy(() => import('../views/settings/AddEditWeightMesmentUnit')))
const Routing = Loadable(lazy(() => import('../views/settings/Routing')))
const AddEditRouting = Loadable(lazy(() => import('../views/settings/AddEditRouting')))
const MainRoute = Loadable(lazy(() => import('../views/settings/MainRoute')))
const AddEditMainRoute = Loadable(lazy(() => import('../views/settings/AddEditMainRoute')))
const DriverTripInformation = Loadable(lazy(() => import('../views/settings/DriverTripInformation')))
const AddEditDriverTripInfo = Loadable(lazy(() => import('../views/settings/AddEditDriverTripInfo')))
const AddEditAssignTrip = Loadable(lazy(() => import('../views/settings/AddEditAssignTrip')))
const TruckInfo = Loadable(lazy(() => import('../views/settings/TruckInfo')))
const AddEditTruckInfo = Loadable(lazy(() => import('../views/settings/AddEditTruckInfo')))
const ThirdpartyCredentials = Loadable(lazy(() => import('../views/settings/ThirdpartyCredentials')))
const AddEditThirdpartyCredentials = Loadable(lazy(() => import('../views/settings/AddEditThirdpartyCredentials')))
const LanguagesSettings = Loadable(lazy(() => import('../views/settings/LanguagesSettings')))
const ThirdPartyCarriers = Loadable(lazy(() => import('../views/settings/ThirdPartyCarriers')))
const PromoAndCouponCode = Loadable(lazy(() => import('../views/settings/PromoAndCouponCode')))
const PromoCouponUsage = Loadable(lazy(() => import('../views/settings/PromoCouponUsage')))
const AddEditPromoCouponCode = Loadable(lazy(() => import('../views/settings/AddEditPromoCouponCode')))
const CreditCardType = (lazy(() => import('../views/settings/CreditCardType')))
const AddEditCreditCardType = (lazy(() => import('../views/settings/AddEditCreditCardType')))
const ContainerType = (lazy(() => import('../views/settings/ContainerType')))

/***** Security ***/
const PostArticle = Loadable(lazy(() => import('../views/Security/PostArticle')))
const AddEditPostArticle = Loadable(lazy(() => import('../views/Security/AddEditPostArticle')))
const Employee = Loadable(lazy(() => import('../views/Security/Employee/Employee')))
const AddEditEmployee = Loadable(lazy(() => import('../views/Security/Employee/AddEdit/AddEditEmployee')))
const PageSettings = Loadable(lazy(() => import('../views/Security/PageSettings/PageSettings')))
const Logins = Loadable(lazy(() => import('../views/Security/Logins/Logins')))
const AddEditLogins = Loadable(lazy(() => import('../views/Security/Logins/AddEdit/AddEditLogins')))
const SmtpDetails = Loadable(lazy(() => import('../views/Security/SMTPDetails/SmtpDetails')))
const AddEditSmtpDetails = Loadable(lazy(() => import('../views/Security/SMTPDetails/AddEdit/AddEditSmtpDetails')))
const EmailTemplate = Loadable(lazy(() => import('../views/Security/EmailTemplate/EmailTemplate')))
const AddEditEmailTemplate = Loadable(lazy(() => import('../views/Security/EmailTemplate/AddEdit/AddEditEmailTemplate')))
const MenuAccess = Loadable(lazy(() => import('../views/Security/MenuAccess/MenuAccess')))
const Menu = Loadable(lazy(() => import('../views/Security/Menu/Menu')))
const AddEditMenu = Loadable(lazy(() => import('../views/Security/Menu/AddEdit/AddEditMenu')))
const Roles = Loadable(lazy(() => import('../views/Security/Roles/Roles')))
const AddEditRoles = Loadable(lazy(() => import('../views/Security/Roles/AddEdit/AddEditRoles')))
const AddEditCustomerPanel = Loadable(lazy(() => import('../views/Security/Menu/AddEdit/AddEditCustomerPanel')))
/***** Barcode Scan ***/
const BarcodeScan = Loadable(lazy(() => import('../views/BarcodeScan/BarcodeScan')))

/***** Supports ***/

const SupportTicket = Loadable(lazy(() => import('../views/Support/SupportTickets/SupportTicket')))
const AddEditSupportTicket = Loadable(lazy(() => import('../views/Support/SupportTickets/AddEdit/AddEditSupportTicket')))
// const Track=Loadable(lazy(()=>import('../views/Support/Track/Track')))
const Tracking = Loadable(lazy(() => import('../views/Support/Track/Tracking')))
const TaskandRemainders = Loadable(lazy(() => import('../views/Support/TaskandRemainders/TaskandRemainders')))

const AddEditTaskandRemainders = Loadable(lazy(() => import('../views/Support/TaskandRemainders/AddEdit/AddEditTaskandRemainders')))
const Purchasehistory = Loadable(lazy(() => import('../views/Support/PurchaseHistory/Purchasehistory')))
const AddEditPurchasehistory = Loadable(lazy(() => import('../views/Support/PurchaseHistory/AddEdit/AddEditPurchasehistory')))

/********* Subscription ********/
const MyPackage = Loadable(lazy(() => import('../views/Subscription/MyPackage/MyPackage')))
const ChangePackagePlan = Loadable(lazy(() => import('../views/Subscription/ChangePackagePlan/ChangePackagePlan')))
const SetUpPlan = Loadable(lazy(() => import('../views/Subscription/SetUpPlan/SetUpPlan')))

/***** Reports ***/

const PromoCouponUsageDev = Loadable(lazy(() => import('../views/Reports/PromoCouponUsageDev')))
const AgencyCommissionReport = Loadable(lazy(() => import('../views/Reports/AgencyCommissionReport')))
const BranchWiseRevenueReport = Loadable(lazy(() => import('../views/Reports/BranchWiseRevenueReport')))
const CustomerBalanceDetailsReport = Loadable(lazy(() => import('../views/Reports/CustomerBalanceDetailsReport')))
const ItemDestinationCountryReport = Loadable(lazy(() => import('../views/Reports/ItemDestinationCountryReport')))
const WarehouseBranchWiseReport = Loadable(lazy(() => import('../views/Reports/WarehouseBranchWiseReport')))
const YearWiseRevenueReport = Loadable(lazy(() => import('../views/Reports/YearWiseRevenueReport')))

/***** Ui Elements ****/
const Alerts = Loadable(lazy(() => import('../views/ui/Alerts')))
const Badges = Loadable(lazy(() => import('../views/ui/Badges')))
const Buttons = Loadable(lazy(() => import('../views/ui/Buttons')))
const Cards = Loadable(lazy(() => import('../views/ui/Cards')))
const Grid = Loadable(lazy(() => import('../views/ui/Grid')))
const Tables = Loadable(lazy(() => import('../views/ui/Tables')))
const Forms = Loadable(lazy(() => import('../views/ui/Forms')))
const Breadcrumbs = Loadable(lazy(() => import('../views/ui/Breadcrumbs')))
const Dropdowns = Loadable(lazy(() => import('../views/ui/DropDown')))
const BtnGroup = Loadable(lazy(() => import('../views/ui/BtnGroup')))
const Collapse = Loadable(lazy(() => import('../views/ui/Collapse')))
const ListGroup = Loadable(lazy(() => import('../views/ui/ListGroup')))
const Modal = Loadable(lazy(() => import('../views/ui/Modal')))
const Navbar = Loadable(lazy(() => import('../views/ui/Navbar')))
const Nav = Loadable(lazy(() => import('../views/ui/Nav')))
const Pagination = Loadable(lazy(() => import('../views/ui/Pagination')))
const Popover = Loadable(lazy(() => import('../views/ui/Popover')))
const Progress = Loadable(lazy(() => import('../views/ui/Progress')))
const Spinner = Loadable(lazy(() => import('../views/ui/Spinner')))
const Tabs = Loadable(lazy(() => import('../views/ui/Tabs')))
const Toasts = Loadable(lazy(() => import('../views/ui/Toasts')))
const Tooltip = Loadable(lazy(() => import('../views/ui/Tooltip')))

/***** Form Layout Pages ****/
const FormBasic = Loadable(lazy(() => import('../views/form-layouts/FormBasic')))
const FormGrid = Loadable(lazy(() => import('../views/form-layouts/FormGrid')))
const FormGroup = Loadable(lazy(() => import('../views/form-layouts/FormGroup')))
const FormInput = Loadable(lazy(() => import('../views/form-layouts/FormInput')))
const FormEditor = Loadable(lazy(() => import('../views/form-editor/FormEditor')))

/***** Form Pickers Pages ****/
const Datepicker = Loadable(lazy(() => import('../views/form-pickers/DateTimePicker')))
const TagSelect = Loadable(lazy(() => import('../views/form-pickers/TagSelect')))

/***** Form Validation Pages ****/
const FormValidate = Loadable(lazy(() => import('../views/form-validation/FormValidation')))
const FormSteps = Loadable(lazy(() => import('../views/form-steps/Steps')))

/***** Table Pages ****/
const Basictable = Loadable(lazy(() => import('../views/tables/TableBasic')))
const CustomReactTable = Loadable(lazy(() => import('../views/tables/CustomReactTable')))
const ReactBootstrapTable = Loadable(lazy(() => import('../views/tables/ReactBootstrapTable')))

/***** Chart Pages ****/
const ApexCharts = Loadable(lazy(() => import('../views/charts/ApexCharts')))
const ChartJs = Loadable(lazy(() => import('../views/charts/ChartJs')))

/***** Sample Pages ****/
const StarterKit = Loadable(lazy(() => import('../views/sample-pages/StarterKit')))
const Profile = Loadable(lazy(() => import('../views/sample-pages/Profile')))
const Gallery = Loadable(lazy(() => import('../views/sample-pages/Gallery')))
const SearchResult = Loadable(lazy(() => import('../views/sample-pages/SearchResult')))
const HelperClass = Loadable(lazy(() => import('../views/sample-pages/HelperClass')))

/***** Icon Pages ****/
const Bootstrap = Loadable(lazy(() => import('../views/icons/Bootstrap')))
const Feather = Loadable(lazy(() => import('../views/icons/Feather')))

/***** Map Pages ****/
const CustomVectorMap = Loadable(lazy(() => import('../views/maps/CustomVectorMap')))

/***** Widget Pages ****/
const Widget = Loadable(lazy(() => import('../views/widget/Widget')))

/***** CASL Access Control ****/
const CASL = Loadable(lazy(() => import('../views/apps/accessControlCASL/AccessControl')))

/***** Auth Pages ****/
const Error = Loadable(lazy(() => import('../views/auth/Error')))
const RegisterFormik = Loadable(lazy(() => import('../views/auth/RegisterFormik')))
const LoginFormik = Loadable(lazy(() => import('../views/auth/LoginFormik')))
const Maintanance = Loadable(lazy(() => import('../views/auth/Maintanance')))
const LockScreen = Loadable(lazy(() => import('../views/auth/LockScreen')))
const RecoverPassword = Loadable(lazy(() => import('../views/auth/RecoverPassword')))
const ForgetPassword = Loadable(lazy(() => import('../views/auth/ForgotPasswordForm')))
const ResetPassword = Loadable(lazy(() => import('../views/auth/ResetPasswordForm')))
const VersionRelease = Loadable(lazy(() => import('../views/auth/VersionRelease')))


/****** Quick Action ********/
const AddQuickWareHouseRecipt = Loadable(lazy(() => import('../views/forms/QuickWareHouseReceipt')))

/****** BETA ********/
const QWRecipt = Loadable(lazy(() => import('../views/Beta/QuickWarehouseReceipt')))
const PL = Loadable(lazy(() => import('../views/Beta/PackingList')))
const PLAddEdit = Loadable(lazy(() => import('../views/Beta/AddEditPackingList')))
const WareHouseReceipt = Loadable(lazy(() => import('../views/Beta/WarehouseReceipt')))
const AddEditWareHouseReceipt = Loadable(lazy(() => import('../views/Beta/AddEditWarehouseReceipt')))
const AdditionalService = Loadable(lazy(() => import('../views/Beta/AdditionalService')))
const AddEditAdditionalService = Loadable(lazy(() => import('../views/Beta/AddEditAdditionalService')))
const Inhouse = Loadable(lazy(() => import('../views/Beta/InhouseWayBill')))
const InhouseEdit = Loadable(lazy(() => import('../views/Beta/EditInhouseWayBill')))
const MasterBill = Loadable(lazy(() => import('../views/Beta/MasterWayBill')))
const EditWarehouseReceipt = Loadable(lazy(() => import('../views/Transactions/warehouserreceipt/add/EditWarehouseReceipt')))


/*****Routes******/

const ThemeRoutes = [
  {
    path: '/',
    element: <FullLayout />,
    children: [
      // { path: '/', name: 'Home', element: <Navigate to='/Dashboard/Dashboard' /> },
      { path: '/', name: 'Home', element: <Navigate to='/auth/login' /> },
      {
        path: '/Dashboard',
        name: 'Dashboard',
        exact: true,
        element: <Dashboard />,
      },

      { path: '/Dashboard', name: 'Dashboard', exact: true, element: <Dashboard /> },
      { path: '/AgentDashboard', name: 'AgentDashboard', exact: true, element: <AgentDashboard /> },

      { path: '/dashboards/demographical', name: 'Demographical', exact: true, element: <Demographical /> },


      { path: '/dashboards/analytical', name: 'Analytical', exact: true, element: <Analytical /> },
      {
        path: '/dashboards/demographical',
        name: 'Demographical',
        exact: true,
        element: <Demographical />,
      },
      { path: '/dashboards/modern', name: 'Modern', exact: true, element: <Modern /> },
      { path: '/about', name: 'about', exact: true, element: <About /> },
      { path: '/apps/notes', name: 'notes', exact: true, element: <Notes /> },
      { path: '/apps/chat', name: 'chat', exact: true, element: <Chat /> },
      { path: '/apps/contacts', name: 'contacts', exact: true, element: <Contacts /> },
      { path: '/apps/calendar', name: 'calendar', exact: true, element: <Calendar /> },
      { path: '/apps/email', name: 'email', exact: true, element: <Email /> },
      { path: '/ecom/shop', name: 'email', exact: true, element: <Shop /> },
      { path: '/ecom/shopdetail', name: 'email', exact: true, element: <ShopDetail /> },
      { path: '/tickt/ticket-list', name: 'ticket list', exact: true, element: <TicketList /> },
      {
        path: '/tickt/ticket-detail',
        name: 'ticket detail',
        exact: true,
        element: <TicketDetail />,
      },
      { path: '/apps/treeview', name: 'email', exact: true, element: <Treeview /> },
      { path: '/ui/alerts', name: 'alerts', exact: true, element: <Alerts /> },
      { path: '/ui/badges', name: 'badges', exact: true, element: <Badges /> },
      { path: '/ui/buttons', name: 'buttons', exact: true, element: <Buttons /> },
      { path: '/ui/cards', name: 'cards', exact: true, element: <Cards /> },
      { path: '/ui/grid', name: 'grid', exact: true, element: <Grid /> },
      { path: '/ui/table', name: 'table', exact: true, element: <Tables /> },
      { path: '/ui/forms', name: 'forms', exact: true, element: <Forms /> },
      { path: '/ui/breadcrumbs', name: 'breadcrumbs', exact: true, element: <Breadcrumbs /> },
      { path: '/ui/dropdown', name: 'dropdown', exact: true, element: <Dropdowns /> },
      { path: '/ui/button-group', name: 'button group', exact: true, element: <BtnGroup /> },
      { path: '/ui/collapse', name: 'collapse', exact: true, element: <Collapse /> },
      { path: '/ui/list-group', name: 'list-group', exact: true, element: <ListGroup /> },
      { path: '/ui/modal', name: 'modal', exact: true, element: <Modal /> },
      { path: '/ui/navbar', name: 'navbar', exact: true, element: <Navbar /> },
      { path: '/ui/nav', name: 'nav', exact: true, element: <Nav /> },
      { path: '/ui/pagination', name: 'pagination', exact: true, element: <Pagination /> },
      { path: '/ui/popover', name: 'popover', exact: true, element: <Popover /> },
      { path: '/ui/progress', name: 'progress', exact: true, element: <Progress /> },
      { path: '/ui/spinner', name: 'spinner', exact: true, element: <Spinner /> },
      { path: '/ui/tabs', name: 'tabs', exact: true, element: <Tabs /> },
      { path: '/ui/toasts', name: 'toasts', exact: true, element: <Toasts /> },
      { path: '/ui/tooltip', name: 'tooltip', exact: true, element: <Tooltip /> },
      { path: '/form-layout/form-basic', name: 'form-basic', exact: true, element: <FormBasic /> },
      { path: '/form-layout/form-grid', name: 'form-grid', exact: true, element: <FormGrid /> },
      { path: '/form-layout/form-group', name: 'form-group', exact: true, element: <FormGroup /> },
      { path: '/form-layout/form-input', name: 'form-input', exact: true, element: <FormInput /> },

      { path: '/WareHouse/WareHouseLocation', name: 'WareHouseLocation', exact: true, element: <WareHouseLocation /> },
      {
        path: '/WareHouse/AddEditWareHouseLocation',
        name: 'AddEditWareHouseLocation',
        exact: true,
        element: <AddEditWareHouseLocation />,
      },
      { path: '/WareHouse/WareHouseZone', name: 'WareHouseZone', exact: true, element: <WareHouseZone /> },
      {
        path: '/WareHouse/AddEditWareHouseZone',
        name: 'AddEditWareHouseZone',
        exact: true,
        element: <AddEditWareHouseZone />,
      },
      { path: '/WareHouse/WareHouseRack', name: 'WareHouseRack', exact: true, element: <WareHouseRack /> },
      {
        path: '/WareHouse/AddEditWareHouseRack',
        name: 'AddEditWareHouseRack',
        exact: true,
        element: <AddEditWareHouseRack />,
      },
      { path: '/WareHouse/WareHouseShelve', name: 'WareHouseShelve', exact: true, element: <WareHouseShelve /> },
      {
        path: '/WareHouse/AddEditWareHouseShelve',
        name: 'AddEditWareHouseShelve',
        exact: true,
        element: <AddEditWareHouseShelve />,
      },
      { path: '/WareHouse/AddWarehouse', name: 'AddWarehouseGrid', exact: true, element: <AddWarehouseGrid /> },

      { path: '/WareHouse', name: 'Warehouse', exact: true, element: <Warehouse /> },
      { path: '/WareHouse/AddEditWarehouse', name: 'AddEditWarehouse', exact: true, element: <AddEditWarehouse /> },
      { path: '/WareHouse/ItemInventory', name: 'ItemInventory', exact: true, element: <ItemInventory /> },

      { path: '/Rates/CustomerRates', name: 'CustomerRate', exact: true, element: <CustomerRate /> },
      {
        path: '/Rates/AddEditCustomerRate',
        name: 'AddEditCustomerRate',
        exact: true,
        element: <AddEditCustomerRate />,
      },

      { path: '/Rates/AgencyRates', name: 'AgencyRate', exact: true, element: <AgencyRate /> },

      {
        path: '/Rates/AddEditAgencyRate',
        name: 'AddEditAgencyRate',
        exact: true,
        element: <AddEditAgencyRate />,
      },
      { path: '/Rates/CarrierRates', name: 'CarrierRate', exact: true, element: <CarrierRate /> },

      {
        path: '/Rates/CarrierRates/AddEdit/AddEditCarrierRate/:labelVal/:idk',
        name: 'AddEditCarrierRate',
        exact: true,
        element: <AddEditCarrierRate />,
      },
      { path: '/Rates/StorageRates', name: 'StorageRate', exact: true, element: <StorageRate /> },

      {
        path: '/Rates/StorageRates/AddEdit/AddEditStorageRate/:labelVal/:idk',
        name: 'AddEditStorageRate',
        exact: true,
        element: <AddEditStorageRate />,
      },
      { path: '/Rates/RateUnit', name: 'RateUnit', exact: true, element: <RateUnit /> },

      { path: '/Orders/Quotation', name: 'Quotation', exact: true, element: <Quotation /> },
      { path: '/Orders/PickupOrder', name: 'PickupOrder', exact: true, element: <PickupOrder /> },
      { path: '/Orders/AddEditPickupOrder', name: 'AddEditPickupOrder', exact: true, element: <AddEditPickupOrder /> },
      { path: '/Orders/AddEditQuotation', name: 'AddEditQuotation', exact: true, element: <AddEditQuotationNew /> },

      { path: '/Transactions/WarehouseReceipt', name: 'warehousereceipt', exact: true, element: <Warehousereceipt /> },
      { path: '/Transactions/AddEditWarehouseReceipt', name: 'AddWarehouse', exact: true, element: <AddWarehouse /> },
      { path: '/Transactions/InhouseWayBill', name: 'InhouseWayBill', exact: true, element: <InhouseWayBill /> },
      { path: '/Transactions/InhouseWayBill/AddEdit/AddEditInhouseWayBill/:labelVal/:idk', name: 'AddEditInhouseWayBill', exact: true, element: <AddEditInhouseWayBill /> },
      { path: '/Transactions/EditInhouseWayBill', name: 'EditInhouseWayBill', exact: true, element: <EditInhouseWayBill /> },
      { path: '/Transactions/MasterWayBill', name: 'Masterwaybill', exact: true, element: <Masterwaybill /> },
      { path: '/Transactions/EditMasterWayBill', name: 'EditMasterWayBill', exact: true, element: <EditMasterWayBill /> },
      {
        path: '/Transactions/MasterWayBill/AddEdit/Addeditmasterwaybill/:labelVal/:idk',
        name: 'addeditmasterwaybill',
        exact: true,
        element: <Addeditmasterwaybill />,
      },
      { path: '/Transactions/PickingList', name: 'PickingList', exact: true, element: <PickingList /> },
      // {
      //   path: 'AddEditPickingList/:labelVal/:idk',
      //   name: 'AddEditPickingList',
      //   exact: true,
      //   element: <AddEditPickingList />,
      // },
      { path: '/Transactions/AddEditPickingList', name: 'AddEditPickingList', exact: true, element: <AddEditPickingList /> },
      { path: '/Transactions/PackingList', name: 'PackingList', exact: true, element: <PackingList /> },
      { path: '/Transactions/EditPackingList', name: 'AddEditPackingList', exact: true, element: <AddEditPackingList /> },

      { path: '/Transactions/CargoRelease', name: 'CargoRelease', exact: true, element: <CargoRelease /> },
      {
        path: '/Transactions/CargoRelease/AddEdit/AddEditCargoReleasepage/:labelVal/:idk',
        name: 'AddEditCargoReleasepage',
        exact: true,
        element: <AddEditCargoReleasepage />,
      },
      { path: '/Transactions/Liquidation', name: 'Liquidation', exact: true, element: <Liquidation /> },
      { path: '/Transactions/Invoice', name: 'Invoice', exact: true, element: <Invoice /> },
      { path: '/Transactions/PaymentHistory', name: 'PaymentHistory', exact: true, element: <PaymentHistory /> },
      { path: '/Transactions/TransactionDetails', name: 'TransactionDetails', exact: true, element: <TransactionDetails /> },
      
      { path: '/Transactions/Tasks', name: 'Tasks', exact: true, element: <Tasks /> },
      { path: '/Transactions/RulesDescription', name: 'RulesDescription', exact: true, element: <RulesDescription /> },
      {
        path: '/Transactions/ProjectRequestDashboard/ProjectRequestDashboard',
        name: 'ProjectRequestDashboard',
        exact: true,
        element: <ProjectRequestDashboard />,
      },
      {
        path: '/Transactions/AddEditRulesDescription',
        name: 'AddEditRulesDescription',
        exact: true,
        element: <AddEditRulesDescription />,
      },
      {
        path: '/Transactions/ProjectRequestDashboard/AddEdit/AddEditProjectRequestDashboard/:labelVal/:idk',
        name: 'AddEditProjectRequestDashboard',
        exact: true,
        element: <AddEditProjectRequestDashboard />,
      },
      {
        path: '/Transactions/RuleForCountry',
        name: 'RuleforCountry',
        exact: true,
        element: <RuleforCountry />,
      },
      {
        path: '/Transactions/AddEditRuleforCountry',
        name: 'AddEditRuleforCountry',
        exact: true,
        element: <AddEditRuleforCountry />,
      },
      {
        path: '/Customers',
        name: 'AddCustomer',
        exact: true,
        element: <AddCustomer />,
      },
      {
        path: '/Customers/AddEditCustomer',
        name: 'AddEditCustomer',
        exact: true,
        element: <AddEditCustomer />,
      },
      {
        path: '/Master/PushNotifications',
        name: 'PushNotifications',
        exact: true,
        element: <PushNotifications />,
      },
      {
        path: 'AddEditPushNotifications/:labelVal/:idk',
        name: 'AddEditPushNotifications',
        exact: true,
        element: <AddEditPushNotifications />,
      },
      {
        path: '/Master/Commodity',
        name: 'Commodity',
        exact: true,
        element: <Commodity />,
      },
      {
        path: '/Master/Plans',
        name: 'plans',
        exact: true,
        element: <Plans />,
      },

      {
        path: '/Master/AddandEditPlans',
        name: '/Master/AddandEditPlans',
        exact: true,
        element: <AddandEditPlans />,
      },

      { path: '/Master/AddEditCommodity', name: 'AddEditCommodity', exact: true, element: <AddEditCommodity /> },
      {
        path: '/Master/PostArticleCategories',
        name: 'PostArticleCategories',
        exact: true,
        element: <PostArticleCategories />,
      },
      { path: '/Master/AddEditPostArticleCategories', name: 'AddEditPostArticleCategories', exact: true, element: <AddEditPostArticleCategories /> },

      {
        path: '/Master/Country',
        name: 'country',
        exact: true,
        element: <Country />,
      },
      {
        path: '/Master/State',
        name: 'state',
        exact: true,
        element: <State />,
      },
      { path: '/Master/Cities', name: 'cities', exact: true, element: <Cities /> },
      { path: '/Master/Port', name: 'port', exact: true, element: <Port /> },
      { path: '/Master/Agency', name: 'Agency', exact: true, element: <Agency /> },
      {
        path: '/Master/AddandEditAgency',
        name: 'AddandEditAgency',
        exact: true,
        element: <AddandEditAgency />,
      },
      {
        path: '/Master/Carrier',
        name: 'Carrier',
        exact: true,
        element: <Carrier />,
      },
      {
        path: '/Master/AddandEditCarrier',
        name: 'AddandEditCarrier',
        exact: true,
        element: <AddandEditCarrier />,
      },
      {
        path: '/Master/BusinessType',
        name: 'BusinessType',
        exact: true,
        element: <BusinessType />,
      },
      { path: '/Master/AddandEditBusinesstype', name: 'AddandEditBusinesstype', exact: true, element: <AddandEditBusinesstype /> },
      //{ path: '/Master/AddandEditBusinesstype', name: 'AddandEditBusinesstype', exact: true, element: <AddandEditBusinesstype /> },
      {
        path: '/Master/AdditionalUsers',
        name: 'AdditionalUsers',
        exact: true,
        element: <AdditionalUsers />,
      },
      {
        path: '/Master/AddEditAdditionalUsers',
        name: 'AddEditAdditionalUsers',
        exact: true,
        element: <AddEditAdditionalUsers />,
      },
      {
        path: '/Master/Service',
        name: 'Service',
        exact: true,
        element: <Service />,
      },
      {
        path: '/Master/AddEditService',
        name: 'AddEditService',
        exact: true,
        element: <AddEditService />,
      },
      {
        path: '/Master/Package',
        name: 'Package',
        exact: true,
        element: <Package />,
      },
      {
        path: '/Master/AddEditPackage',
        name: 'AddEditPackage',
        exact: true,
        element: <AddEditPackage />,
      },
      {
        path: '/Master/QuickService',
        name: 'QuickService',
        exact: true,
        element: <QuickService />,
      },
      { path: '/Master/AddEditQuickService', name: 'AddEditQuickService', exact: true, element: <AddEditQuickService /> },
      { path: '/Master/EditCountry', name: 'EditCountry', exact: true, element: <EditCountry /> },

      { path: '/Master/EditState', name: 'EditState', exact: true, element: <EditState /> },
      { path: '/Master/EditCity', name: 'EditCity', exact: true, element: <EditCity /> },
      { path: '/Master/AddEditPort', name: 'AddEditPort', exact: true, element: <AddEditPort /> },
      {
        path: '/Security/PostArticle',
        name: 'PostArticle',
        exact: true,
        element: <PostArticle />,
      },
      {
        path: '/AddEditPostArticle/:labelVal/:idk',
        name: 'AddEditPostArticle',
        exact: true,
        element: <AddEditPostArticle />,
      },
      {
        path: '/Security/Employee',
        name: 'Employee',
        exact: true,
        element: <Employee />,
      },

      {
        path: '/Security/Employee/AddEdit/AddEditEmployee',
        name: 'AddEditEmployee',
        exact: true,
        element: <AddEditEmployee />,
      },
      {
        path: '/Security/Logins',
        name: 'Logins',
        exact: true,
        element: <Logins />,
      },
      {
        path: '/Security/AddEditLogins',
        name: 'AddEditLogins',
        exact: true,
        element: <AddEditLogins />,
      },
      {
        path: '/Security/PageSettings',
        name: 'PageSettings',
        exact: true,
        element: <PageSettings />,
      },
      {
        path: '/Security/SmtpDetails',
        name: 'SmtpDetails',
        exact: true,
        element: <SmtpDetails />,
      },
      {
        path: 'AddEdit/AddEditSmtpDetails/:labelVal/:idk',
        name: 'AddEditSmtpDetails',
        exact: true,
        element: <AddEditSmtpDetails />,
      },
      {
        path: '/Security/EmailTemplate',
        name: 'EmailTemplate',
        exact: true,
        element: <EmailTemplate />,
      },
      { path: '/Security/AddEditEmailTemplate', name: 'Add Or Edit EmailTemplate', exact: true, element: <AddEditEmailTemplate /> },
      {
        path: '/Security/MenuAccess',
        name: 'MenuAccess',
        exact: true,
        element: <MenuAccess />,
      },
      {
        path: '/Security/Menu',
        name: 'Menu',
        exact: true,
        element: <Menu />,
      },
      {
        path: 'AddEdit/AddEditMenu/:labelVal/:idk',
        name: 'AddEditMenu',
        exact: true,
        element: <AddEditMenu />,
      },
      {
        path: 'AddEdit/AddEditCustomerPanel/:labelVal/:idk',
        name: 'AddEditCustomerPanel',
        exact: true,
        element: <AddEditCustomerPanel />,
      },
      {
        path: '/Security/Roles',
        name: 'Roles',
        exact: true,
        element: <Roles />,
      },
      {
        path: '/Security/AddEditRoles',
        name: 'AddEditRoles',
        exact: true,
        element: <AddEditRoles />,
      },
      // {
      //   path: '/settings/HubAndHubZone',
      //   name: 'HubAndHubZone',
      //   exact: true,
      //   element: <HubAndHubZone />,
      // },
      // {
      //   path: '/settings/HubZone',
      //   name: 'HubZone',
      //   exact: true,
      //   element: <HubZoneAndHub />,
      // },
      {
        path: '/Settings/Hub',
        name: 'Hub',
        exact: true,
        element: <Hub />,
      },
      {
        path: '/Settings/HubZone',
        name: 'HubZone',
        exact: true,
        element: <HubZone />,
      },
      {
        path: '/Settings/AddEditHub',
        name: 'AddEditHub',
        exact: true,
        element: <AddEditHub />,
      },
      {
        path: '/Settings/AddEditHubZone',
        name: 'AddEditHubZone',
        exact: true,
        element: <AddEditHubZone />,
      },
      {
        path: '/Settings/ItemStatus',
        name: 'ItemStatus',
        exact: true,
        element: <ItemStatus />,
      },
      {
        path: '/Settings/AddEditItemStatus',
        name: 'AddEditItemStatus',
        exact: true,
        element: <AddEditItemStatus />,
      },
      {
        path: 'AddEditMasterStatus/:labelVal/:statusid',
        name: 'AddEditMasterStatus',
        exact: true,
        element: <AddEditMasterStatus />,
      },
      {
        path: '/Settings/RateType',
        name: 'RateType',
        exact: true,
        element: <RateType />,
      },
      {
        path: '/Settings/AddEditRateType',
        name: 'AddEditRateType',
        exact: true,
        element: <AddEditRateType />,
      },
      {
        path: '/Settings/CustomerType',
        name: 'CustomerType',
        exact: true,
        element: <CustomerType />,
      },
      {
        path: '/Settings/AddEditCustomerType',
        name: 'AddEditCustomerType',
        exact: true,
        element: <AddEditCustomerType />,
      },
      {
        path: '/Settings/PaymentGateway',
        name: 'Paymentgateway',
        exact: true,
        element: <Paymentgateway />,
      },
      // {
      //   path: 'AddEditpaymentgateway/:labelVal/:idk',
      //   name: 'AddEditpaymentgateway',
      //   exact: true,
      //   element: <AddEditpaymentgateway />,
      // },
      {
        path: '/settings/AddEditpaymentgateway',
        name: 'AddEditpaymentgateway',
        exact: true,
        element: <AddEditpaymentgateway />,
      },
      {
        path: '/Settings/PaymentType',
        name: 'Paymenttype',
        exact: true,
        element: <Paymenttype />,
      },
      {
        path: '/Settings/AddEditpaymentType',
        name: 'AddEditpaymenttype',
        exact: true,
        element: <AddEditpaymenttype />,
      },
      {
        path: '/Settings/PackageType',
        name: 'PackageType',
        exact: true,
        element: <PackageType />,
      },
      {
        path: '/Settings/AddEditPackageType',
        name: 'AddEditPackageType',
        exact: true,
        element: <AddEditPackageType />,
      },
      {
        path: '/Settings/AdditionalServices',
        name: 'AdditionalServices',
        exact: true,
        element: <AdditionalServices />,
      },
      {
        path: '/Settings/AddEditAdditonSRV',
        name: 'AddEditAdditonSRV',
        exact: true,
        element: <AddEditAdditonSRV />,
      },
      {
        path: '/Settings/ShipmentType',
        name: 'ShipmentType',
        exact: true,
        element: <ShipmentType />,
      },
      {
        path: '/Settings/ServiceType',
        name: 'ServiceType',
        exact: true,
        element: <ServiceType />,
      },
      {
        path: '/Settings/AddEditServiceType',
        name: 'AddEditServiceType',
        exact: true,
        element: <AddEditServiceType />,
      },
      {
        path: '/Settings/AddEditShipmentType',
        name: 'AddEditShipmentType',
        exact: true,
        element: <AddEditShipmentType />,
      },
      {
        path: '/Settings/Branch',
        name: 'Branch',
        exact: true,
        element: <Branch />,
      },
      {
        path: '/Settings/AddEditBranch',
        name: 'AddEditBranch',
        exact: true,
        element: <AddEditBranch />,
      },
      {
        path: '/Settings/CustomerAccountType',
        name: 'CustomerAccountType',
        exact: true,
        element: <CustomerAccountType />,
      },
      {
        path: 'AddEditCustAccType/:labelVal/:idk',
        name: 'AddEditCustAccType',
        exact: true,
        element: <AddEditCustAccType />,
      },
      {
        path: '/Settings/DriverInfo',
        name: 'DriverInfo',
        exact: true,
        element: <DriverInfo />,
      },
      {
        path: '/Settings/AddEditDriverInfo',
        name: 'AddEditDriverInfo',
        exact: true,
        element: <AddEditDriverInfo />,
      },
      {
        path: '/Settings/WeightMeasurementUnits',
        name: 'WeightmeasurementUnits',
        exact: true,
        element: <WeightmeasurementUnits />,
      },
      {
        path: '/Settings/AddEditWeightMesmentUnit',
        name: 'AddEditWeightMesmentUnit',
        exact: true,
        element: <AddEditWeightMesmentUnit />,
      },
      {
        path: '/Settings/Routing',
        name: 'Routing',
        exact: true,
        element: <Routing />,
      },
      {
        path: '/Settings/AddEditRouting',
        name: 'AddEditRouting',
        exact: true,
        element: <AddEditRouting />,
      },
      {
        path: '/Settings/MainRoute',
        name: 'MainRoute',
        exact: true,
        element: <MainRoute />,
      },
      {
        path: 'AddEditMainRoute/:labelVal/:idk',
        name: 'AddEditMainRoute',
        exact: true,
        element: <AddEditMainRoute />,
      },
      {
        path: '/Settings/DriverTripInformation',
        name: 'DriverTripInformation',
        exact: true,
        element: <DriverTripInformation />,
      },
      {
        path: '/Settings/ContainerType',
        name: 'ContainerType',
        exact: true,
        element: <ContainerType />,
      },
      {
        path: '/Settings/CreditCardType',
        name: 'CreditCardType',
        exact: true,
        element: <CreditCardType />,
      },
      {
        path: '/Settings/AddEditCreditCardType',
        name: 'AddEditCreditCardType',
        exact: true,
        element: <AddEditCreditCardType />,
      },
      {
        path: '/Settings/AddEditDriverTripInfo',
        name: 'AddEditDriverTripInfo',
        exact: true,
        element: <AddEditDriverTripInfo />,
      },
      {
        path: 'AddEditAssignTrip/:labelVal/:idk',
        name: 'AddEditAssignTrip',
        exact: true,
        element: <AddEditAssignTrip />,
      },
      {
        path: '/Settings/TruckInfo',
        name: 'TruckInfo',
        exact: true,
        element: <TruckInfo />,
      },
      {
        path: '/Settings/AddEditTruckInfo',
        name: 'AddEditTruckInfo',
        exact: true,
        element: <AddEditTruckInfo />,
      },
      {
        path: '/Settings/ThirdPartyCredentials',
        name: 'ThirdpartyCredentials',
        exact: true,
        element: <ThirdpartyCredentials />,
      },
      {
        path: 'AddEditThirdpartyCredentials/:labelVal/:idk',
        name: 'AddEditThirdpartyCredentials',
        exact: true,
        element: <AddEditThirdpartyCredentials />,
      },
      {
        path: '/Settings/LanguageSettings',
        name: 'LanguageSettings',
        exact: true,
        element: <LanguagesSettings />,
      },
      {
        path: '/Settings/ThirdPartyCarriers',
        name: 'ThirdPartyCarriers',
        exact: true,
        element: <ThirdPartyCarriers />,
      },
      {
        path: '/Settings/PromoAndCouponCode',
        name: 'PromoAndCouponCode',
        exact: true,
        element: <PromoAndCouponCode />,
      },
      {
        path: '/Settings/PromoCouponUsage',
        name: 'PromoCouponUsage',
        exact: true,
        element: <PromoCouponUsage />,
      },
      {
        path: 'AddEditPromoCouponCode/:labelVal/:idk',
        name: 'AddEditPromoCouponCode',
        exact: true,
        element: <AddEditPromoCouponCode />,
      },

      {
        path: '/Reports/PromoCouponUsageDev',
        name: 'PromoCouponUsageDev',
        exact: true,
        element: <PromoCouponUsageDev />,
      },
      {
        path: '/Reports/AgencyCommissionReport',
        name: 'AgencyCommissionReport',
        exact: true,
        element: <AgencyCommissionReport />,
      },

      {
        path: '/Reports/BranchWiseRevenueReport',
        name: 'BranchWiseRevenueReport',
        exact: true,
        element: <BranchWiseRevenueReport />,
      },

      {
        path: '/Reports/CustomerBalanceDetailsReport',
        name: 'CustomerBalanceDetailsReport',
        exact: true,
        element: <CustomerBalanceDetailsReport />,
      },

      {
        path: '/Reports/ItemDestinationCountryReport',
        name: 'ItemDestinationCountryReport',
        exact: true,
        element: <ItemDestinationCountryReport />,
      },

      {
        path: '/Reports/WarehouseBranchWiseReport',
        name: 'WarehouseBranchWiseReport',
        exact: true,
        element: <WarehouseBranchWiseReport />,
      },

      {
        path: '/Reports/YearWiseRevenueReport',
        name: 'YearWiseRevenueReport',
        exact: true,
        element: <YearWiseRevenueReport />,
      },
      {
        path: '/BarcodeScan/BarcodeScan',
        name: 'BarcodeScan',
        exact: true,
        element: <BarcodeScan />,
      },
      {
        path: '/Support/CreateTickets',
        name: 'SupportTicket',
        exact: true,
        element: <SupportTicket />,
      },
      {
        path: '/Support/AddEditSupportTicket',
        name: 'AddEditSupportTicket',
        exact: true,
        element: <AddEditSupportTicket />,
      },
      // {
      //   path: '/Support/Track/Track',
      //   name: 'Track',
      //   exact: true,
      //   element: <Track />,
      // },
      {
        path: '/Support/Track',
        name: 'Tracking',
        exact: true,
        element: <Tracking />,
      },
      {
        path: '/Support/TaskandRemainders/TaskandRemainders',
        name: 'TaskandRemainders',
        exact: true,
        element: <TaskandRemainders />,
      },
      {
        path: '/Support/TaskandRemainders/AddEdit/AddEditTaskandRemainders/:labelVal/:idk',
        name: 'AddEditTaskandRemainders',
        exact: true,
        element: <AddEditTaskandRemainders />,
      },
      {
        path: '/Support/PurchaseHistory',
        name: 'PurchaseHistory',
        exact: true,
        element: <Purchasehistory />,
      },
      {
        path: '/Support/Purchasehistory/AddEdit/AddEditPurchasehistory/:labelVal/:idk',
        name: 'AddEditPurchasehistory',
        exact: true,
        element: <AddEditPurchasehistory />,
      },

      {
        path: '/Subscroption/MyPackage',
        name: 'MyPackage',
        exact: true,
        element: <MyPackage />,
      },
      {
        path: '/Subscroption/ChangePackagePlan',
        name: 'ChangePackagePlan',
        exact: true,
        element: <ChangePackagePlan />,
      },
      {
        path: '/Subscroption/SetUpPlan',
        name: 'SetUpPlan',
        exact: true,
        element: <SetUpPlan />,
      },
      {
        path: '/form-pickers/datepicker',
        name: 'datepicker',
        exact: true,
        element: <Datepicker />,
      },
      { path: '/form-pickers/tag-select', name: 'tag-select', exact: true, element: <TagSelect /> },
      { path: '/form-validation', name: 'form-validation', exact: true, element: <FormValidate /> },
      { path: '/form-steps', name: 'form-steps', exact: true, element: <FormSteps /> },
      { path: '/form-editor', name: 'form-editor', exact: true, element: <FormEditor /> },
      { path: '/tables/basic-table', name: 'basic-table', exact: true, element: <Basictable /> },
      {
        path: '/tables/react-table',
        name: 'react-table',
        exact: true,
        element: <CustomReactTable />,
      },
      {
        path: '/tables/data-table',
        name: 'data-table',
        exact: true,
        element: <ReactBootstrapTable />,
      },
      { path: '/charts/apex', name: 'apex', exact: true, element: <ApexCharts /> },
      { path: '/charts/chartjs', name: 'chartjs', exact: true, element: <ChartJs /> },
      { path: '/sample-pages/profile', name: 'profile', exact: true, element: <Profile /> },
      {
        path: '/sample-pages/helper-class',
        name: 'helper-class',
        exact: true,
        element: <HelperClass />,
      },
      {
        path: '/sample-pages/starterkit',
        name: 'starterkit',
        exact: true,
        element: <StarterKit />,
      },
      { path: '/sample-pages/gallery', name: 'gallery', exact: true, element: <Gallery /> },
      {
        path: '/sample-pages/search-result',
        name: 'search-result',
        exact: true,
        element: <SearchResult />,
      },
      { path: '/icons/bootstrap', name: 'bootstrap', exact: true, element: <Bootstrap /> },
      { path: '/icons/feather', name: 'feather', exact: true, element: <Feather /> },
      { path: '/map/vector', name: 'vector', exact: true, element: <CustomVectorMap /> },
      { path: '/widget', name: 'widget', exact: true, element: <Widget /> },
      { path: '/casl', name: 'casl', exact: true, element: <CASL /> },
      { path: '*', element: <Navigate to='/auth/404' /> },
    ],
  },
  {
    path: '/auth',
    element: <BlankLayout />,
    children: [
      { path: '404', element: <Error /> },
      { path: '*', element: <Navigate to='/auth/404' /> },
      { path: 'registerformik', element: <RegisterFormik /> },
      { path: 'login', element: <LoginFormik /> },
      { path: 'maintanance', element: <Maintanance /> },
      { path: 'lockscreen', element: <LockScreen /> },
      { path: 'recoverpwd', element: <RecoverPassword /> },
      { path: 'forgotpassword', element: <ForgetPassword /> },
      { path: 'resetpassword/:token', element: <ResetPassword /> },
      { path: 'versionRelease', element: <VersionRelease /> },

    ],
  },

  {
    path: '/',
    element: <BlankLayout />,
    children: [
      { path: '/AddQuickWareHouseRecipt', name: 'Add Quick WareHouse Recipt', exact: true, element: <AddQuickWareHouseRecipt /> },
      { path: '/QuickWareHouseRecipt/:companyId/:roleId/:userName/:branchCode', name: 'Add Quick WareHouse Recipt', exact: true, element: <QWRecipt /> },
      { path: '/Transactions/PackingList/:companyId/:roleId/:userName/:branchCode', name: 'PackingList', exact: true, element: <PL /> },
      { path: '/Transactions/EditPackingList/:companyId/:roleId/:userName/:branchCode/:packingListId/:typeOfShipment/:mstrNo', name: 'AddEditPackingList', exact: true, element: <PLAddEdit /> },
      { path: '/Transactions/WarehouseRecipt/:companyId/:roleId/:userName/:branchCode', name: 'Warehouse Recipt', exact: true, element: <WareHouseReceipt /> },
      { path: '/Transactions/AddEditWarehouseReceipt/:companyId/:roleId/:userName/:branchCode/:inventId/:wrNumber/:mode', name: 'Add Or Edit Warehouse Recipt', exact: true, element: <AddEditWareHouseReceipt /> },
      { path: '/Settings/AdditionalService/:companyId/:userName/:branchCode', name: 'Additional Service', exact: true, element: <AdditionalService /> },
      { path: '/Settings/AddEditAdditionalService/:companyId/:userName/:branchCode/:status/:asId/:mode', name: 'Add Or Edit Additional Service', exact: true, element: <AddEditAdditionalService /> },
      { path: '/Transactions/InhouseWayBill/:companyId/:roleId/:userName/:branchCode/:userId', name: 'Inhouse', exact: true, element: <Inhouse /> },
      { path: '/Transactions/EditInhouse', name: 'EditInhouseWayBill', exact: true, element: <InhouseEdit /> },
      { path: '/Transactions/MasterWayBill/:companyId/:roleId/:userName/:branchCode', name: 'MasterBill', exact: true, element: <MasterBill /> },
      { path: '/Transactions/EditWarehouseReceipt/:companyId/:roleId/:userName/:branchCode/:inventId/:wrNumber/:mode', name: 'Edit Warehouse Recipt', exact: true, element: <EditWarehouseReceipt /> },

    ],
  },

]

export default ThemeRoutes
